import React from 'react';

export function FormHtml({ label, className }: { label: string; className?: string }) {
	return <div className={className} dangerouslySetInnerHTML={{ __html: label }} />;
}
